import { PlusOutlined, FolderOpenTwoTone, LoadingOutlined } from '@ant-design/icons';
import { Spin } from "antd"
import { DataNode } from "antd/es/tree"
import Tree from "antd/es/tree/Tree"
import { Key, useEffect, useState } from "react"
import { arrayCommon } from '../../helpers/common';
import { LoaiHopDong } from '@app/models/hopdong/HopDong';
import { layDanhMucLoaiHopDong } from '@app/services/danhmuc';

const convertDataTreeView = (data: any) => {
    let chidlrenArr: Array<DataNode> = [];
    if (data) {
        chidlrenArr = data.map((_item: any) => {
            let rs: DataNode = {
                key: _item?.id,
                title: _item?.ten,
                icon: <FolderOpenTwoTone style={{ fontSize: "20px" }} rev="" />,
            }
            return rs;
        })
    }
    return chidlrenArr;
}

const defaultTreeProps = {
    showIcon: true,
    showLine: true,
    multiple: false,
    switcherIcon: <PlusOutlined rev={undefined} />
}

const LoaiHopDongTree = ({ showHeader, onChange, reloadTree }: { showHeader?: boolean, reloadTree?: boolean, onChange: (e: any) => void }) => {
    const [loadingTree, setLoadingTree] = useState<boolean>(false);
    const [dsDonVi, setDsDonVi] = useState<Array<LoaiHopDong>>([]);
    const [treeData, setTreeData] = useState<Array<DataNode>>([]);
    const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin rev="" />;
    const onSelect = (selectedKeys: Key[], info: any) => {
        var dv = arrayCommon.findById(dsDonVi, selectedKeys[0]);
        onChange(dv);
    };
    const layDsDonVi = async () => {
        try {
            setLoadingTree(true);
            let data = await layDanhMucLoaiHopDong();
            setDsDonVi(data);
            setTreeData(convertDataTreeView(data));
            setLoadingTree(false);
        } catch (error: any) {
            setLoadingTree(false);
        };
    }

    useEffect(() => {
        layDsDonVi();
    }, []);

    useEffect(() => {
        if (reloadTree) {
            layDsDonVi();
        }
    }, [reloadTree]);

    return (
        <div className="card card-primary">
            {
                showHeader ?
                    <div className="card-header">
                        <h3 className="card-title">Loại hợp đồng</h3>
                    </div> : null
            }
            <div className="card-body">

                {loadingTree ?
                    <Spin indicator={antIcon} />
                    : <div id="treeView">
                        <Tree
                            showLine={true}
                            showIcon={true}
                            defaultExpandAll={true}
                            onSelect={onSelect}
                            treeData={treeData}
                        />
                    </div>
                }
            </div>
        </div>);
}

export default LoaiHopDongTree;